import { Box, Button, IconButton, SxProps, Typography } from "@mui/material"
import BaseModal from "../modal/baseModal"
import { icons } from "../../utils/icons"
import { DinamicForm } from "../dinamicForm"
import { LoadingButton } from "@mui/lab"
import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"
import { ResendProps, ResendRef } from "./types"
import { forwardRef, Ref, useImperativeHandle, useState } from "react"
import { ObjectGeneric, onChange } from "../../utils/types/generals"
import { isEmailSeparateToCome } from "../../utils/validate/validate"
import { resendReportForm, resendReportFormEmails, resendReportFormUser } from "./contants"
import FilterSelect from "../dinamicForm/filterSelect"

const Resend = forwardRef(({ open, title, inputCustome, loading, errorsResend, isUser, setErrorsResend, send, close, twoButtons, userGroup }: ResendProps, ref: Ref<ResendRef>) => {
    const [data, setData] = useState<ObjectGeneric>({})
    const [disabled, setDisabled] = useState(true)
    const { t } = useTranslation()
    const styles = useStyles()

    useImperativeHandle(ref, () => ({
        clearData: () => {
            setData({})
        }
    }))

    const handleSendReportData: onChange = ({ target }) => {
        const { name, value } = target
        setErrorsResend([])
        const body: ObjectGeneric = {
            ...structuredClone(data),
            [name]: value,
        }

        /* START EMAIL VALIDATE */
        const emailValue = name === 'externalEmails' ? value : body?.externalEmails
        let emailIsSeparate = false
        emailIsSeparate = !(!emailValue || isEmailSeparateToCome(emailValue))
        /* END EMAIL VALIDATE */

        setDisabled(!Object.values(body ?? {})?.some((item) => !!item) || emailIsSeparate)

        setData((prev) => ({
            ...prev ?? {},
            [name]:
                name === 'externalEmails'
                    ? value?.replace(/(\r\n|\n|\r|\s)/gm, '')
                    : value,
            ...(name === 'user_group' && value === false
                ? { selectGroup: [] }
                : {}),
        }))
    }

    return (
        <BaseModal sx={styles.resendModal as SxProps} open={open}>
            <Box style={styles.resendReportContainer as any}>
                <IconButton
                    sx={styles.close}
                    onClick={() => {
                        close()
                        setData({})
                        setDisabled(true)
                    }}
                >
                    {icons('simple-close')}
                </IconButton>

                <Typography variant="h6" component="h2" color='c_grey.main' textAlign={"center"}>{title}</Typography>
                <Typography sx={styles.titleSend}>{t('reportFolio.modal.sendReport.internal')}</Typography>
                <DinamicForm input={Object.values(inputCustome ? inputCustome : (isUser ? resendReportFormUser : resendReportForm))} values={data} onChange={handleSendReportData} spacing={{ row: 0 }} />

                {data.user_group &&
                    <FilterSelect
                        name={'selectGroup'}
                        label={'Grupo'}
                        onChange={handleSendReportData}
                        items={userGroup}
                        selected={data.selectGroup}
                    />
                }

                <Typography sx={styles.titleSend}>{t('reportFolio.modal.sendReport.external')}</Typography>
                <Typography variant="body1" mb={1}>{t('reportFolio.modal.sendReport.emails')}</Typography>

                <DinamicForm input={Object.values(resendReportFormEmails)} values={data} onChange={handleSendReportData} />
                {
                    !!errorsResend?.length && (
                        <Box sx={styles.containerErrorsResend}>
                            <Typography>{t(`reportFolio.modal.sendReport.01`)}:</Typography>

                            <ul>
                                {
                                    errorsResend?.map((item, index) => (
                                        <li><Typography>* {item}</Typography></li>
                                    ))
                                }
                            </ul>
                        </Box>
                    )
                }
                <Box sx={!!twoButtons ? styles.resendButton : styles.resendButtonContainer}>
                    {twoButtons &&
                        <Button
                            onClick={() => {
                                close()
                                setData({})
                                setDisabled(true)
                            }}
                            sx={styles.cancelBtn}
                        >
                            {t('reportFolio.detail.general.cancel')}
                        </Button>
                    }
                    <LoadingButton
                        loading={!!loading}
                        disabled={!!disabled}
                        type="submit"
                        onClick={() => {
                            send({ data })
                        }}
                        variant="primary_c"
                    >
                        {t('reportFolio.buttons.resend')}
                    </LoadingButton>
                </Box>
            </Box>
        </BaseModal>
    )
})

export { Resend }
